export const formatK = (n) => {
  const v = Number(n) || 0;
  if (v < 1000) return String(v);
  const k = Math.floor(v / 100) / 10;
  return `${Number.isInteger(k) ? k : k.toFixed(1)}k`;
};
